export const AUTH_TOKEN__INVALID_JWT_FORMAT = 'auth_token__invalid_jwt_format';

export const YG_CABINET_DEEPLINK_SUCCESS = 'yg_cabinet_deepLink_success';

export const YG_CABINET_DEEPLINK_ERROR = 'yg_cabinet_deepLink_error';

export const YG_CABINET_DEEPLINK_CLICK = 'yg_cabinet_deepLink_click';

export const YG_CABINET_VIDEO_PLAYER_ERROR = 'yg_cabinet_video_player_error';

export const YG_CABINET_VIDEO_PLAYER_LOAD = 'yg_cabinet_video_player_load';
